import type { ReactNode } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import { readStoreCache } from '@/offline'

/**
 * Seva Mandir V1 or the full build for the store screens, from the store list's config.scope
 * (the server's SCOPE, as on the roster). Before the list is downloaded the phone takes V1, the
 * roster's default; null while the list is being read.
 */
export function useStoreScope(): { v1: boolean; siteKind: string | null } | null {
  const stored = useLiveQuery(async () => (await readStoreCache()) ?? null, [], undefined)
  if (stored === undefined) return null
  const config = stored?.cache.config ?? {}
  return {
    v1: config['scope'] !== 'FULL',
    siteKind: typeof config['site_kind'] === 'string' ? config['site_kind'] : null,
  }
}

/** The V1 board or the full screen for one store route. */
export function StoreByScope({ v1, full }: { v1: ReactNode; full: ReactNode }) {
  const scope = useStoreScope()
  if (!scope) return null
  return <>{scope.v1 ? v1 : full}</>
}
